"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgOrderNote = function (props) {
    var color = props.color;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M4 2c-1.102 0-2 .898-2 2v16c0 1.102.898 2 2 2h12c1.102 0 2-.898 2-2v-7.036l1.756-1.683 1.5-1.516v-.001A2.57 2.57 0 0 0 22 8.049c.024-.746-.28-1.499-.938-2.16-.659-.663-1.423-.977-2.225-.868a2.508 2.508 0 0 0-.836.275V4c0-1.102-.898-2-2-2zm9.788 15L16 14.88V20H4V4h12v3.162a172.38 172.38 0 0 1-3.754 3.869A1.002 1.002 0 0 0 12 11H7a1 1 0 1 0 0 2h3.152l-.152.134V15H7a1 1 0 1 0 0 2h6.788m2.988-7.75c-.268.283-.557.584-.857.896-1.268 1.317-2.77 2.841-3.919 3.887V15h.985l4.87-4.666-1.079-1.084m2.497-.325.562-.568.002-.002A.57.57 0 0 0 20 7.983c.004-.117-.03-.354-.357-.683-.324-.326-.493-.303-.536-.297-.107.014-.291.1-.535.346l-.005.006-.016.017-.054.056-.177.188-.082.087-.087.093 1.122 1.129M7 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z", clipRule: "evenodd" }));
};
exports.default = factorySvgIcon_1.default(SvgOrderNote);
//# sourceMappingURL=SvgOrderNote.js.map